import { createSelector } from '@reduxjs/toolkit'

export const followUpPromptsSelector = state => state.followUpPromptsReducer

export const getFetching = () =>
  createSelector(
    followUpPromptsSelector,
    followUpPrompts => followUpPrompts.fetching
  )

export const getPrompts = () =>
  createSelector(
    followUpPromptsSelector,
    followUpPrompts => followUpPrompts.prompts
  )
